import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import Card from "@material-tailwind/react/Card";
import Button from "@material-tailwind/react/Button";
import { useMutation } from "@tanstack/react-query";
import {
  fetchPost,
  fetchGet,
  fetchPostMultipartSeaweed,
} from "../../../fetchers";
import { HrdInputGenerator } from "../../../components/form/HrdInputGenerator";
import { toast } from "react-toastify";
import Spinner from "../../../components/spinner/Spinner";
import { GetKaryawanMinV2 } from "../../hrd/karyawan/karyawanSlice";
import { isRequired, useForm } from "../../../components/isRequired";
import { getMinBagian } from "../../master/bagian/bagianSlice";
import draftToHtml from "draftjs-to-html";
import { convertToRaw } from "draft-js";
import { TextEditor } from "./TextEditor";
import { v4 as uuidv4 } from "uuid";

const MemoDetailPage = () => {
  let initialState = {
    Progress: "-1",
    to: "", // To - default akan diisi dengan pengirim memo
    Cc: [], // CC - default akan diisi dengan CC sebelumnya
    description: "",
    NamaFile: null,
  };

  const mutation = useMutation((param) =>
    fetchGet("getInternalMemoDetail/" + param),
  );

  const mutationAdd = useMutation((param) =>
    fetchPost("SubmitInternalMemo", param),
  );

  const mutationFile = useMutation((formData) =>
    fetchPostMultipartSeaweed(formData),
  );

  const validations = [
    ({ description }) =>
      isRequired(description) || { Description: "Description wajib diisi" },
  ];

  const {
    values,
    errors,
    touched,
    changeHandler,
    customHandler,
    changeArrayHandler,
    setValues,
  } = useForm(initialState, validations);

  const [buttonTouched, setButtonTouched] = useState(false);
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [datas, setDatas] = useState({});
  const [defaultTo, setDefaultTo] = useState("");
  const [defaultToName, setDefaultToName] = useState("");
  const [defaultCc, setDefaultCc] = useState([]);
  const [isInitialized, setIsInitialized] = useState(false);
  const [isMemoCreator, setIsMemoCreator] = useState(false);
  const [memoCreatorNik, setMemoCreatorNik] = useState("");
  const [isUploading, setIsUploading] = useState(false);
  const [uploadedFileName, setUploadedFileName] = useState("");
  const [fileUploadError, setFileUploadError] = useState(false);

  const authUser = JSON.parse(localStorage.getItem("user"))?.Nik;

  // Helper function untuk mendapatkan value dengan berbagai kemungkinan case
  const getFieldValue = (obj, fieldName) => {
    if (!obj || !fieldName) return null;

    const possibleCases = [
      fieldName,
      fieldName.toLowerCase(),
      fieldName.toUpperCase(),
      fieldName.charAt(0).toLowerCase() + fieldName.slice(1),
      fieldName.charAt(0).toUpperCase() + fieldName.slice(1),
    ];

    for (const caseVariant of possibleCases) {
      if (obj[caseVariant] !== undefined && obj[caseVariant] !== null) {
        return obj[caseVariant];
      }
    }

    for (const key in obj) {
      if (obj[key] && typeof obj[key] === "object") {
        for (const caseVariant of possibleCases) {
          if (
            obj[key][caseVariant] !== undefined &&
            obj[key][caseVariant] !== null
          ) {
            return obj[key][caseVariant];
          }
        }
      }
    }

    return null;
  };

  const safeString = (value) => {
    if (value === null || value === undefined) return "";

    if (typeof value === "object") {
      if (value.String !== undefined) return String(value.String);
      if (value.Valid !== undefined) return String(value.Valid);
      if (value.value !== undefined) return String(value.value);
      if (value.name !== undefined) return String(value.name);
      if (value.Name !== undefined) return String(value.Name);
      if (value.NIK !== undefined) return String(value.NIK);
      if (value.nik !== undefined) return String(value.nik);
      if (value.Nik !== undefined) return String(value.Nik);
      return JSON.stringify(value);
    }
    return String(value);
  };

  const getNameFromObject = (obj) => {
    if (!obj) return "";
    if (typeof obj === "string") return obj;
    if (typeof obj === "object") {
      return safeString(
        obj.Name ||
          obj.name ||
          obj.NAMA ||
          obj.From ||
          obj.from ||
          obj.Nama ||
          obj.nama,
      );
    }
    return String(obj);
  };

  const getNikFromObject = (obj) => {
    if (!obj) return "";
    if (typeof obj === "string") return obj;
    if (typeof obj === "object") {
      return safeString(
        obj.Nik || obj.nik || obj.NIK || obj.id || obj.Id || obj.ID,
      );
    }
    return String(obj);
  };


  const findCCFromMemoData = (memoData, senderNik) => {
    let ccList = [];

    const ccData =
      getFieldValue(memoData, "ccList") ||
      getFieldValue(memoData, "Cc") ||
      getFieldValue(memoData, "cc") ||
      [];

    if (Array.isArray(ccData) && ccData.length > 0) {
      ccList = ccData
        .map((cc) => getNikFromObject(cc))
        .filter((cc) => cc && cc.trim() !== "" && cc !== senderNik);
    }

    console.log("📋 CC ditemukan:", ccList);
    return ccList;
  };

  // Fungsi untuk mendeteksi apakah user adalah pembuat memo
  const detectMemoCreator = (memoData) => {
    console.log("🔍 Deteksi pembuat memo...");
    console.log("User login:", authUser);

    const creatorFields = ["nikFrom", "From", "from", "createdBy", "CreatedBy"];
    let creatorNik = null;

    for (const field of creatorFields) {
      const value = getFieldValue(memoData, field);
      if (value) {
        creatorNik = getNikFromObject(value);
        console.log(
          `✅ Ditemukan pembuat memo dari field '${field}':`,
          creatorNik,
        );
        break;
      }
    }

    if (!creatorNik) {
      const list = getArrayValue(memoData, "list");
      if (Array.isArray(list) && list.length > 0) {
        const firstItem = list[0];
        for (const field of creatorFields) {
          const value = getFieldValue(firstItem, field);
          if (value) {
            creatorNik = getNikFromObject(value);
            console.log(
              `✅ Ditemukan pembuat memo dari list[0] field '${field}':`,
              creatorNik,
            );
            break;
          }
        }
      }
    }

    setMemoCreatorNik(creatorNik);

    const isCreator = creatorNik === authUser;
    setIsMemoCreator(isCreator);

    console.log("📊 Hasil deteksi:");
    console.log("- Pembuat memo:", creatorNik);
    console.log("- User login:", authUser);
    console.log("- Apakah pembuat memo?", isCreator);

    return creatorNik;
  };

  const getArrayValue = (obj, fieldName) => {
    const value = getFieldValue(obj, fieldName);
    return Array.isArray(value) ? value : [];
  };

  // Default "To" = pengirim pesan TERAKHIR yang bukan user login.
  // Contoh: A membuat memo, B membuka → balas ke A. B membalas, A membuka → balas ke B.
  const computeDefaultTo = (memoData) => {
    const msgs = [];
    const rootNik = getNikFromObject(getFieldValue(memoData, "nikFrom"));
    const rootName = getNameFromObject(getFieldValue(memoData, "from"));
    const rootDate = getFieldValue(memoData, "date");
    if (rootNik) msgs.push({ nik: rootNik, name: rootName || "Pengirim", date: rootDate });

    getArrayValue(memoData, "list").forEach((r) => {
      const nik = getNikFromObject(getFieldValue(r, "nikFrom"));
      if (!nik) return;
      msgs.push({
        nik,
        name: getNameFromObject(getFieldValue(r, "from")) || "Pengirim",
        date: getFieldValue(r, "date"),
      });
    });

    // Urut menaik berdasarkan tanggal, ambil pesan terakhir dari orang lain.
    msgs.sort((a, b) => new Date(a.date || 0) - new Date(b.date || 0));
    for (let i = msgs.length - 1; i >= 0; i--) {
      if (msgs[i].nik && msgs[i].nik !== authUser) return msgs[i];
    }

    // Fallback: penerima asli, lalu pembuat.
    const toList = getArrayValue(memoData, "toList");
    if (toList.length > 0) {
      return { nik: getNikFromObject(toList[0]), name: getNameFromObject(toList[0]) };
    }
    return { nik: rootNik, name: rootName };
  };

  useEffect(() => {
    if (params.id) {
      mutation.mutate(params.id);
      customHandler(params.id, "Id");
    }
    dispatch(getMinBagian({ search: "" }));
    dispatch(GetKaryawanMinV2({ search: "" }));
  }, [params.id, dispatch]);

  useEffect(() => {
    if (!mutation.isLoading && mutation.isSuccess && !isInitialized) {
      console.log("🚀 Data memo berhasil diambil");
      const memoData = mutation.data.data;
      setDatas(memoData);
      setIsInitialized(true);

      detectMemoCreator(memoData);

      const senderInfo = computeDefaultTo(memoData);

      if (senderInfo.nik) {
        setDefaultTo(senderInfo.nik);
        setDefaultToName(senderInfo.name || "Pengirim");
        setTimeout(() => {
          customHandler(senderInfo.nik, "to");
        }, 100);
      }

      const ccList = findCCFromMemoData(memoData, senderInfo.nik);
      if (ccList.length > 0) {
        setDefaultCc(ccList);
        setTimeout(() => {
          customHandler(ccList, "Cc");
          console.log("✅ Default CC telah di-set ke form:", ccList);
        }, 100);
      }
    }
  }, [mutation.isLoading, mutation.isSuccess, isInitialized]);

  // Progress options berdasarkan apakah user adalah pembuat memo
  const getProgressOptions = () => {
    const baseOptions = [
      { value: -1, label: "Open" },
      { value: 0, label: "Progress" },
    ];

    if (isMemoCreator) {
      return [...baseOptions, { value: 99, label: "Close" }];
    }

    return baseOptions;
  };

  const progressOptions = getProgressOptions();

  const resetToToDefault = () => {
    if (defaultTo) {
      customHandler(defaultTo, "to");
      toast.info("To telah direset ke pengirim asli", {
        position: "bottom-right",
        autoClose: 3000,
      });
    }
  };

  const resetCcToDefault = () => {
    if (defaultCc && defaultCc.length > 0) {
      customHandler(defaultCc, "Cc");
      toast.info("CC telah direset ke default", {
        position: "bottom-right",
        autoClose: 3000,
      });
    }
  };

  const getDataFromURL = (url) => {
    url = safeString(url).replaceAll("/", "-");
    fetch(process.env.REACT_APP_API_UPLOAD_URL + "file/" + url, {
      method: "GET",
    })
      .then((response) => response.blob())
      .then((data) => {
        const file = window.URL.createObjectURL(data);
        window.open(file);
      })
      .catch((err) => {
        console.error("Error loading file:", err);
      });
  };

  const Kirim = async () => {
    // Validasi
    if (!values.description || values.description.trim() === "") {
      toast.error("Description wajib diisi", {
        position: "bottom-right",
        autoClose: 5000,
      });
      return;
    }

    if (!values.to || values.to.trim() === "") {
      toast.error("To wajib diisi", {
        position: "bottom-right",
        autoClose: 5000,
      });
      return;
    }

    if (values.Progress === "99" && !isMemoCreator) {
      toast.error("Hanya pembuat memo yang dapat menutup memo", {
        position: "bottom-right",
        autoClose: 5000,
      });
      return;
    }

    if (values.Progress === "99") {
      const confirmed = window.confirm(
        "⚠️ PERHATIAN!\n\nAnda akan menutup memo ini secara permanen.\n" +
          "Setelah ditutup, memo tidak dapat dibalas lagi.\n\n" +
          "Apakah Anda yakin ingin melanjutkan?",
      );

      if (!confirmed) {
        return;
      }
    }

    // Reset state
    setFileUploadError(false);

    // Siapkan payload awal
    const payload = {
      Id: params.id,
      To: values.to,
      Cc: values.Cc || [],
      description: values.description,
      Status: "1",
      Progress: values.Progress?.toString() || "0",
      NamaFile: "",
    };

    console.log("📤 Mengirim payload:", payload);
    console.log("👤 Apakah pembuat memo?", isMemoCreator);

    // Cek apakah ada file yang perlu diupload
    const file = values.NamaFile; // File dari form

    if (file && file instanceof File) {
      console.log("📁 File ditemukan, mulai proses upload...");
      setIsUploading(true);

      // Generate nama file unik
      const uuid = uuidv4();
      const originalName = file.name;
      const safeName = originalName.replace(/[^a-zA-Z0-9.-]/g, "_");
      const fileName = `${uuid}-${safeName}`;

      console.log("📁 File info:", {
        originalName,
        fileName,
        size: file.size,
        type: file.type,
      });

      // SELALU simpan nama file ke payload
      // Ini kunci utama: Nama file disimpan meskipun upload gagal
      payload.NamaFile = fileName;
      console.log("📝 Nama file disimpan ke payload:", fileName);

      try {
        // Buat FormData untuk upload
        const formData = new FormData();
        formData.append("file", file, fileName);

        // Upload file - coba upload
        const uploadResult = await mutationFile.mutateAsync(formData);
        console.log("✅ Upload berhasil:", uploadResult);

        setUploadedFileName(fileName);
        setFileUploadError(false);

        toast.success("File berhasil diupload!", {
          position: "bottom-right",
          autoClose: 3000,
        });
      } catch (error) {
        console.error("❌ Upload file gagal:", error);

        // TETAP simpan nama file meskipun upload gagal
        payload.NamaFile = fileName; // Masih simpan nama file
        setFileUploadError(true);

        toast.warning(
          "Upload file gagal, tetapi nama file tetap disimpan di database. File tidak akan tersedia untuk di-download.",
          {
            position: "bottom-right",
            autoClose: 5000,
          },
        );
      } finally {
        setIsUploading(false);
      }
    } else if (file && typeof file === "string") {
      // Jika file sudah berupa string (nama file)
      payload.NamaFile = file;
      setUploadedFileName(file);
      console.log("📁 Menggunakan nama file yang sudah ada:", file);
    } else if (uploadedFileName) {
      // Jika sudah ada uploadedFileName dari state
      payload.NamaFile = uploadedFileName;
      console.log(
        "📁 Menggunakan uploadedFileName dari state:",
        uploadedFileName,
      );
    }

    // Debug payload sebelum dikirim
    console.log("=== FINAL PAYLOAD ===");
    console.log("Payload:", JSON.stringify(payload, null, 2));
    console.log("NamaFile value:", payload.NamaFile);
    console.log("NamaFile length:", payload.NamaFile?.length || 0);
    console.log("=== END DEBUG ===");

    // Kirim ke backend
    mutationAdd.mutate(payload, {
      onSuccess: (data, context) => {
        console.log("✅ Response dari backend:", data);
        console.log(
          "📁 Nama file yang disimpan di database:",
          payload.NamaFile,
        );

        // Reset state
        setUploadedFileName("");
        setFileUploadError(false);

        toast.success(
          "Memo berhasil dikirim" +
            (fileUploadError ? " (tanpa file attachment)" : ""),
          {
            position: "bottom-right",
            autoClose: 5000,
          },
        );

        navigate("/memo/internalmemo");
      },
      onError: (error, context) => {
        console.error("❌ Error dari backend:", error);

        let errorMessage = "Gagal mengirim memo";
        if (error.response) {
          console.error("Error response:", error.response);
          errorMessage = `Gagal mengirim memo: ${error.response.status} - ${
            error.response.data?.message || "Unknown error"
          }`;
        } else if (error.message) {
          errorMessage = error.message;
        }

        toast.error(errorMessage, {
          position: "bottom-right",
          autoClose: 5000,
        });
      },
    });
  };

  const getMemoNumber = () => {
    const noMemo = getFieldValue(datas, "noMemo");
    const nomorMemo = getFieldValue(datas, "nomorMemo");

    if (noMemo && noMemo.trim() !== "") {
      return noMemo;
    }
    if (nomorMemo && nomorMemo.trim() !== "") {
      return nomorMemo;
    }
    return "-";
  };

  const formatDateDisplay = (dateString) => {
    try {
      if (!dateString) return "";

      // Normalisasi: ganti T jadi spasi, buang ms & timezone
      const clean = dateString
        .toString()
        .replace("T", " ")
        .split(".")[0]
        .split("Z")[0];

      // expected: YYYY-MM-DD HH:mm:ss
      const [datePart, timePart = "00:00:00"] = clean.split(" ");
      if (!datePart) return safeString(dateString);

      const [year, month, day] = datePart.split("-");
      const [hours, minutes] = timePart.split(":");

      if (!year || !month || !day) return safeString(dateString);

      return `${day}/${month}/${year} ${hours}:${minutes}`;
    } catch (error) {
      return safeString(dateString);
    }
  };

  // Format untuk menampilkan nama file di UI
  const getDisplayFileName = () => {
    if (values.NamaFile) {
      if (values.NamaFile instanceof File) {
        return values.NamaFile.name;
      } else if (typeof values.NamaFile === "string") {
        return values.NamaFile;
      }
    }
    if (uploadedFileName) {
      return uploadedFileName;
    }
    return null;
  };

  const displayFileName = getDisplayFileName();

  return (
    <>
      {mutation.isLoading ? (
        <div className="flex items-center">
          <Spinner />
        </div>
      ) : (
        <div className="md:ml-64">
          {/* Info Panel */}
          <div className="px-3 md:px-8 pt-4 mb-3">
            <span
              className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-sm font-medium ${
                isMemoCreator
                  ? "bg-green-50 text-green-700 border border-green-200"
                  : "bg-blue-50 text-blue-700 border border-blue-200"
              }`}
            >
              {isMemoCreator ? "Pembuat memo — dapat menutup memo" : "Peserta memo"}
              {memoCreatorNik && !isMemoCreator && (
                <span className="text-blue-500">· Pembuat: {memoCreatorNik}</span>
              )}
            </span>
          </div>

          <div className="px-3 md:px-8 h-auto">
            <div className="container mx-auto max-w-full">
              <Card className="w-full">
                <div className="p-3">
                  <div className="flex justify-between items-start mb-4">
                    <h5 className="text-xl font-bold text-gray-900">
                      Internal Memo
                      {isMemoCreator && (
                        <span className="ml-2 text-xs bg-green-100 text-green-800 px-2 py-1 rounded-full">
                          Created by You
                        </span>
                      )}
                    </h5>
                    <div className="text-right">
                      <div className="text-sm font-medium text-gray-500">
                        ID: {getFieldValue(datas, "id") || "-"}
                      </div>
                      <div className="text-xs text-gray-400">
                        {isMemoCreator ? "Pembuat Memo" : "View Only"}
                      </div>
                    </div>
                  </div>

                  <table className="table-auto w-full bg-transparent border-collapse text-sm">
                    <tbody>
                      <tr>
                        <td className="w-1/4 font-medium">Nomor Memo</td>
                        <td className="w-6 text-center">:</td>
                        <td className="w-3/4">
                          <code className="font-mono bg-gray-100 px-2 py-1 rounded border text-sm">
                            {getMemoNumber()}
                          </code>
                        </td>
                      </tr>

                      <tr>
                        <td className="w-1/4 font-medium">Status</td>
                        <td className="w-6 text-center">:</td>
                        <td className="w-3/4">
                          <span
                            className={`px-2 py-1 rounded-full text-xs font-semibold ${
                              getFieldValue(datas, "approved") === 99
                                ? "bg-green-100 text-green-800"
                                : getFieldValue(datas, "approved") === 0
                                  ? "bg-yellow-100 text-yellow-800"
                                  : "bg-blue-100 text-blue-800"
                            }`}
                          >
                            {getFieldValue(datas, "approved") === 99
                              ? "Close"
                              : getFieldValue(datas, "approved") === 0
                                ? "Progress"
                                : "Open"}
                          </span>
                        </td>
                      </tr>

                      <tr>
                        <td className="w-1/4 font-medium">Dibuat Oleh</td>
                        <td className="w-6 text-center">:</td>
                        <td className="w-3/4">
                          <div className="font-medium">
                            {getNameFromObject(getFieldValue(datas, "from"))}
                          </div>
                          {getFieldValue(datas, "nikFrom") && (
                            <div className="text-xs text-gray-500">
                              NIK:{" "}
                              {getNikFromObject(
                                getFieldValue(datas, "nikFrom"),
                              )}
                            </div>
                          )}
                        </td>
                      </tr>

                      <tr>
                        <td className="w-1/4 font-medium">Tanggal Dibuat</td>
                        <td className="w-6 text-center">:</td>
                        <td className="w-3/4">
                          {formatDateDisplay(getFieldValue(datas, "date"))}
                        </td>
                      </tr>

                      <tr>
                        <td className="w-1/4 font-medium">Subjek</td>
                        <td className="w-6 text-center">:</td>
                        <td className="w-3/4 font-medium text-gray-900">
                          {safeString(getFieldValue(datas, "subject"))}
                        </td>
                      </tr>

                      {/* Separator */}
                      <tr>
                        <td colSpan="3" className="py-2">
                          <div className="border-t border-gray-200"></div>
                        </td>
                      </tr>

                      <tr>
                        <td className="w-1/4 font-medium align-top pt-2">
                          Kepada
                        </td>
                        <td className="w-6 text-center align-top pt-2">:</td>
                        <td className="w-3/4 align-top pt-2">
                          {(() => {
                            const toList = getArrayValue(datas, "toList");
                            return toList.length > 0 ? (
                              toList.map((to, i) => (
                                <div key={i} className="mb-1">
                                  <span className="font-medium">
                                    {getNameFromObject(to)}
                                  </span>
                                  <span className="text-xs text-gray-500 ml-2">
                                    ({getNikFromObject(to)})
                                  </span>
                                </div>
                              ))
                            ) : (
                              <span className="text-gray-500">-</span>
                            );
                          })()}
                        </td>
                      </tr>

                      <tr>
                        <td className="w-1/4 font-medium align-top">CC</td>
                        <td className="w-6 text-center align-top">:</td>
                        <td className="w-3/4 align-top">
                          {(() => {
                            const ccList = getArrayValue(datas, "ccList");
                            return ccList.length > 0 ? (
                              ccList.map((cc, i) => (
                                <div key={i} className="mb-1">
                                  <span className="font-medium">
                                    {getNameFromObject(cc)}
                                  </span>
                                  <span className="text-xs text-gray-500 ml-2">
                                    ({getNikFromObject(cc)})
                                  </span>
                                </div>
                              ))
                            ) : (
                              <span className="text-gray-500">-</span>
                            );
                          })()}
                        </td>
                      </tr>

                      <tr>
                        <td className="w-1/4 font-medium">Attachment</td>
                        <td className="w-6 text-center">:</td>
                        <td className="w-3/4">
                          {(() => {
                            const file = getFieldValue(datas, "file");
                            return file && file !== "" ? (
                              <div className="flex items-center">
                                <button
                                  onClick={() => getDataFromURL(file)}
                                  className="flex flex-row items-center bg-blue-50 hover:bg-blue-100 text-blue-700 font-medium py-1 px-3 border border-blue-200 rounded shadow-sm"
                                >
                                  <span className="mr-2">📎</span>
                                  Lihat Attachment
                                </button>
                                <div className="ml-3 text-xs text-gray-500 truncate max-w-xs">
                                  {safeString(file)}
                                </div>
                              </div>
                            ) : (
                              <span className="text-gray-500">
                                Tidak ada attachment
                              </span>
                            );
                          })()}
                        </td>
                      </tr>

                      <tr>
                        <td className="align-top font-medium pt-4">
                          Deskripsi
                        </td>
                        <td className="align-top pt-4">:</td>
                        <td className="pl-3 border border-gray-300 rounded bg-gray-50 mt-4">
                          {(() => {
                            const desc = getFieldValue(datas, "desc");
                            return desc ? (
                              <div
                                className="p-4"
                                dangerouslySetInnerHTML={{
                                  __html: safeString(desc),
                                }}
                              ></div>
                            ) : (
                              <div className="p-4 text-gray-500 italic">
                                Tidak ada deskripsi
                              </div>
                            );
                          })()}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </Card>
            </div>
          </div>

          <div className="p-3"></div>

          <div className="px-3 md:px-8 h-auto">
            <div className="flex flex-row flex-wrap items-start justify-start w-full px-2 py-2">
              {params.for === "action" ? (
                <Card className="md:w-1/2">
                  <div className="p-3">
                    <h5 className="text-xl font-bold text-gray-900 pb-5">
                      Action
                      {isMemoCreator && (
                        <span className="ml-2 text-xs bg-green-100 text-green-800 px-2 py-1 rounded-full">
                          Can Close
                        </span>
                      )}
                    </h5>

                    {/* Text Editor - WAJIB */}
                    <div className="w-full mb-6">
                      <TextEditor
                        onClick={changeHandler}
                        onChange={(e) =>
                          customHandler(
                            draftToHtml(convertToRaw(e.getCurrentContent())),
                            "description",
                          )
                        }
                      />
                      {(!values.description ||
                        values.description.trim() === "") && (
                        <div className="text-red-500 text-sm mt-1">
                          Description wajib diisi
                        </div>
                      )}
                    </div>

                    {/* Form Grid */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {/* TO */}
                      <div className="flex flex-col">
                        <div className="flex justify-between items-center mb-1">
                          <label className="block text-sm font-medium text-gray-700">
                            To *
                          </label>
                          {defaultTo && values.to !== defaultTo && (
                            <button
                              type="button"
                              onClick={resetToToDefault}
                              className="text-xs text-blue-600 hover:text-blue-800 underline"
                            >
                              Reset ke default
                            </button>
                          )}
                        </div>

                        <HrdInputGenerator
                          type="karyawan"
                          value={values}
                          name="to"
                          onChange={customHandler}
                          touched={touched}
                          buttonTouched={buttonTouched}
                          size="full"
                          required
                          errors={errors}
                          disabled={false}
                          defaultValue={defaultTo}
                        />

                        {defaultTo && (
                          <div className="mt-1 text-xs text-gray-500 flex items-center">
                            <span className="mr-1">⚡</span>
                            Default:{" "}
                            <span className="font-medium ml-1">
                              {defaultToName} ({defaultTo})
                            </span>
                            {!values.to && (
                              <span className="ml-2 text-green-600">
                                ✓ Terisi otomatis
                              </span>
                            )}
                          </div>
                        )}
                      </div>

                      {/* CC */}
                      <div className="flex flex-col">
                        <div className="flex justify-between items-center mb-1">
                          <label className="block text-sm font-medium text-gray-700">
                            CC (Tambahan)
                          </label>
                          {defaultCc.length > 0 && (
                            <button
                              type="button"
                              onClick={resetCcToDefault}
                              className="text-xs text-blue-600 hover:text-blue-800 underline"
                            >
                              Reset ke default
                            </button>
                          )}
                        </div>

                        <HrdInputGenerator
                          type="multipleSelect"
                          value={values}
                          name="Cc"
                          onChange={changeArrayHandler}
                          touched={touched}
                          buttonTouched={buttonTouched}
                          size="full"
                          errors={errors}
                          disabled={false}
                          placeholder="Pilih CC tambahan..."
                          defaultValue={defaultCc}
                        />

                        {(() => {
                          const ccList = getArrayValue(datas, "ccList");
                          return ccList.length > 0 ? (
                            <div className="mt-1 text-xs text-gray-500">
                              <span className="mr-1">📋</span>
                              CC default dari memo:{" "}
                              <span className="font-medium">
                                {ccList
                                  .map(
                                    (cc) =>
                                      `${getNameFromObject(
                                        cc,
                                      )} (${getNikFromObject(cc)})`,
                                  )
                                  .join(", ")}
                              </span>
                            </div>
                          ) : null;
                        })()}

                        {values.Cc && values.Cc.length > 0 && (
                          <div className="mt-1 text-xs text-blue-600">
                            <span className="mr-1">✅</span>
                            Dipilih: {values.Cc.length} orang
                          </div>
                        )}
                      </div>

                      {/* Progress */}
                      <div className="flex flex-col">
                        <div className="flex justify-between items-center mb-1">
                          <label className="block text-sm font-medium text-gray-700">
                            Progress
                          </label>
                          {isMemoCreator && (
                            <span className="text-xs bg-green-100 text-green-800 px-2 py-1 rounded">
                              Dapat menutup
                            </span>
                          )}
                        </div>

                        <Select
                          options={progressOptions}
                          value={progressOptions.find(
                            (opt) =>
                              opt.value.toString() ===
                              values.Progress?.toString(),
                          )}
                          onChange={(selectedOption) => {
                            customHandler(
                              selectedOption.value.toString(),
                              "Progress",
                            );
                          }}
                          placeholder="Pilih progress..."
                          className="basic-single"
                          classNamePrefix="select"
                          isDisabled={progressOptions.length === 0}
                        />

                        <div className="mt-1 text-xs text-gray-500">
                          {isMemoCreator ? (
                            <div className="flex items-center">
                              <span className="mr-1">🔓</span>
                              Anda dapat memilih "Close" untuk menutup memo
                            </div>
                          ) : (
                            <div className="flex items-center">
                              <span className="mr-1">🔒</span>
                              Hanya pembuat memo yang dapat menutup
                            </div>
                          )}

                          {values.Progress === "99" && (
                            <div className="mt-1 p-2 bg-red-50 border border-red-200 rounded text-red-700">
                              <div className="flex items-center">
                                <span className="mr-2">⚠️</span>
                                <div>
                                  <strong>PERHATIAN:</strong> Memilih "Close"
                                  akan menutup memo secara permanen. Pastikan
                                  semua hal telah selesai.
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>

                      {/* Attachment */}
                      <div className="w-full px-3 mb-6">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                          {displayFileName && "Ganti "}Attachment
                        </label>

                        <div className="relative">
                          <label
                            htmlFor="NamaFile"
                            className="block w-full border border-gray-300 rounded py-3 px-4 leading-tight outline-none bg-white cursor-pointer hover:bg-gray-50 transition-colors"
                          >
                            {displayFileName ? (
                              <span className="flex items-center">
                                <span className="mr-2">📎</span>
                                <span className="truncate">
                                  {displayFileName}
                                </span>
                              </span>
                            ) : (
                              <span className="flex items-center text-gray-500">
                                <span className="mr-2">📎</span>
                                Pilih file...
                              </span>
                            )}
                          </label>

                          {displayFileName && (
                            <button
                              type="button"
                              onClick={() => {
                                customHandler(null, "NamaFile");
                                setUploadedFileName("");
                                setFileUploadError(false);
                              }}
                              className="absolute right-2 top-1/2 transform -translate-y-1/2 text-red-500 hover:text-red-700"
                              title="Hapus file"
                            >
                              ✕
                            </button>
                          )}
                        </div>

                        <input
                          type="file"
                          id="NamaFile"
                          key="NamaFile"
                          name="NamaFile"
                          className="hidden"
                          onChange={(e) => {
                            const file = e.target.files[0];
                            if (file) {
                              console.log("📁 File dipilih:", {
                                name: file.name,
                                size: file.size,
                                type: file.type,
                              });
                              customHandler(file, "NamaFile");
                              setUploadedFileName("");
                              setFileUploadError(false);
                            }
                          }}
                        />

                        {/* Status upload */}
                        {isUploading && (
                          <div className="mt-2 text-xs text-blue-600 flex items-center">
                            <span className="mr-1 animate-spin">⏳</span>
                            Mengupload file...
                          </div>
                        )}

                        {/* Info file */}
                        {displayFileName && (
                          <div className="mt-2 text-xs text-gray-500">
                            {fileUploadError ? (
                              <span className="text-yellow-600 flex items-center">
                                <span className="mr-1">⚠️</span>
                                Nama file disimpan, tetapi upload gagal:{" "}
                                {displayFileName}
                              </span>
                            ) : uploadedFileName ? (
                              <span className="text-green-600 flex items-center">
                                <span className="mr-1">✅</span>
                                Siap disimpan: {uploadedFileName}
                              </span>
                            ) : values.NamaFile &&
                              values.NamaFile instanceof File ? (
                              <span className="text-blue-600 flex items-center">
                                <span className="mr-1">📁</span>
                                Akan diupload: {values.NamaFile.name}
                              </span>
                            ) : (
                              <span className="text-gray-600">
                                File: {displayFileName}
                              </span>
                            )}
                          </div>
                        )}

                      </div>
                    </div>

                    {/* Catatan ringkas */}
                    <p className="mt-4 text-xs text-gray-500 leading-relaxed">
                      <strong>To</strong> otomatis terisi{" "}
                      <span className="font-medium text-gray-700">
                        {defaultToName || "pengirim terakhir"}
                      </span>{" "}
                      (bisa diganti). <strong>Description</strong> wajib diisi.
                      {isMemoCreator && " Sebagai pembuat, Anda dapat memilih “Close” untuk menutup memo secara permanen."}
                    </p>

                    {/* Submit Button */}
                    <div className="mt-6 flex justify-end space-x-3">
                      <Button
                        color="gray"
                        onClick={() => navigate("/memo/internalmemo")}
                        ripple="light"
                        className="px-6"
                        disabled={isUploading}
                      >
                        Batal
                      </Button>
                      <Button
                        color={values.Progress === "99" ? "red" : "green"}
                        onClick={Kirim}
                        ripple="light"
                        className="px-6"
                        disabled={
                          !values.description ||
                          values.description.trim() === "" ||
                          !values.to ||
                          isUploading
                        }
                      >
                        {isUploading
                          ? "Mengupload..."
                          : values.Progress === "99"
                            ? "Tutup Memo"
                            : "Kirim Balasan"}
                      </Button>

                      {values.Progress === "99" && (
                        <div className="text-xs text-red-600 mt-2 text-right">
                          ⚠️ Aksi ini akan menutup memo secara permanen
                        </div>
                      )}
                    </div>
                  </div>
                </Card>
              ) : (
                ""
              )}

              {/* Comments Section */}
              <Card className="md:w-1/2">
                <div className="p-3">
                  <div className="flex justify-between items-center mb-5">
                    <h5 className="text-xl font-bold text-gray-900">
                      Riwayat Balasan
                    </h5>
                    <div className="text-sm text-gray-500">
                      Total:{" "}
                      {(() => {
                        const list = getArrayValue(datas, "list");
                        return list.length;
                      })()}
                    </div>
                  </div>

                  {(() => {
                    const list = getArrayValue(datas, "list");
                    return list.length > 0 ? (
                      list.map((item, i) => (
                        <div key={i} className="mb-6 last:mb-0">
                          <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                            <div className="flex justify-between items-start mb-3">
                              <div className="flex-1">
                                <div className="flex items-center">
                                  <div className="font-bold text-gray-900">
                                    {getNameFromObject(
                                      getFieldValue(item, "from"),
                                    )}
                                  </div>
                                  {getFieldValue(item, "noMemo") && (
                                    <div className="ml-3 text-xs bg-gray-100 text-gray-700 px-2 py-1 rounded">
                                      <code>
                                        {getFieldValue(item, "noMemo") ||
                                          getFieldValue(item, "nomorMemo") ||
                                          "-"}
                                      </code>
                                    </div>
                                  )}
                                </div>
                                <div className="text-xs text-gray-500 mt-1">
                                  {formatDateDisplay(
                                    getFieldValue(item, "date"),
                                  )}
                                </div>
                                {getFieldValue(item, "approved") !==
                                  undefined && (
                                  <div className="mt-1">
                                    <span
                                      className={`px-2 py-0.5 rounded-full text-xs font-semibold ${
                                        getFieldValue(item, "approved") === 99
                                          ? "bg-green-100 text-green-800"
                                          : getFieldValue(item, "approved") ===
                                              0
                                            ? "bg-yellow-100 text-yellow-800"
                                            : "bg-blue-100 text-blue-800"
                                      }`}
                                    >
                                      {getFieldValue(item, "approved") === 99
                                        ? "Close"
                                        : getFieldValue(item, "approved") === 0
                                          ? "Progress"
                                          : "Open"}
                                    </span>
                                  </div>
                                )}
                              </div>
                              {getFieldValue(item, "file") &&
                                getFieldValue(item, "file") !== "" && (
                                  <button
                                    onClick={() =>
                                      getDataFromURL(
                                        getFieldValue(item, "file"),
                                      )
                                    }
                                    className="text-blue-600 hover:text-blue-800 text-sm flex items-center bg-blue-50 hover:bg-blue-100 px-3 py-1 rounded"
                                  >
                                    <span className="mr-1">📎</span> File
                                  </button>
                                )}
                            </div>
                            <div className="mt-3 text-gray-700">
                              {getFieldValue(item, "desc") ? (
                                <div
                                  className="p-3 bg-white rounded border border-gray-200"
                                  dangerouslySetInnerHTML={{
                                    __html: safeString(
                                      getFieldValue(item, "desc"),
                                    ),
                                  }}
                                ></div>
                              ) : (
                                <div className="p-3 bg-white rounded border border-gray-200 text-gray-500 italic">
                                  Tidak ada deskripsi
                                </div>
                              )}
                            </div>
                            {getFieldValue(item, "file") &&
                              getFieldValue(item, "file") !== "" && (
                                <div className="mt-2 text-xs text-gray-500 flex items-center">
                                  <span className="mr-1">📁</span>
                                  Attachment:{" "}
                                  <span className="ml-1 font-medium">
                                    {safeString(getFieldValue(item, "file"))}
                                  </span>
                                </div>
                              )}
                          </div>
                          {i < list.length - 1 && (
                            <div className="mt-4 border-t border-gray-300"></div>
                          )}
                        </div>
                      ))
                    ) : (
                      <div className="text-center py-8 text-gray-500">
                        <div className="text-xl mb-2">📭</div>
                        Belum ada riwayat balasan
                      </div>
                    );
                  })()}
                </div>
              </Card>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MemoDetailPage;
